export default "__VITE_ASSET__BfhmxRzj__"